import React from 'react';

import { GreyBoxLoader } from '@xarvio/elements';
import { Box, Row, RowCell } from '@xarvio/layout';
import { fieldStatusDetailsPanelSectionLabelSkeletonHeight } from './skeletonConfig';
import type { FieldStatusDetailsPanelContentSkeleton } from './skeletonConfig';

interface Props {
  sectionSkeleton: FieldStatusDetailsPanelContentSkeleton;
}

const FieldStatusDetailsPanelSectionSkeleton = ({ sectionSkeleton }: Props) => (
  <Box hpadding={'medium'} vpadding={sectionSkeleton.vpadding} margin={false}>
    {sectionSkeleton.showLabel && (
      <Row
        align={'center'}
        gaps={'narrow'}
        margin={'mediumSmall'}
        minHeight={sectionSkeleton.labelMinHeight}
      >
        <RowCell auto basis={'12px'} />
        <RowCell>
          <GreyBoxLoader
            style={{
              height: fieldStatusDetailsPanelSectionLabelSkeletonHeight,
              width: sectionSkeleton.labelWidth,
            }}
          />
        </RowCell>
      </Row>
    )}
    <GreyBoxLoader style={{ height: sectionSkeleton.height }} />
  </Box>
);

export { FieldStatusDetailsPanelSectionSkeleton };
